'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _calculateElementSize = require('./calculateElementSize');

var _calculateElementSize2 = _interopRequireDefault(_calculateElementSize);

var _elementConstants = require('../../../common/elements/elementConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = function (Component) {
    var ElementResizeHandleMouse = function (_React$Component) {
        _inherits(ElementResizeHandleMouse, _React$Component);

        function ElementResizeHandleMouse() {
            var _ref;

            var _temp, _this, _ret;

            _classCallCheck(this, ElementResizeHandleMouse);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ElementResizeHandleMouse.__proto__ || Object.getPrototypeOf(ElementResizeHandleMouse)).call.apply(_ref, [this].concat(args))), _this), _this.onMouseMove = function (event) {
                var _this$props = _this.props,
                    setTempElementSize = _this$props.setTempElementSize,
                    gridSize = _this$props.gridSize,
                    element = _this$props.element,
                    minWidth = _this$props.minWidth;

                var elementSize = element.getIn(['content', 'width']);

                event.preventDefault();
                event.stopPropagation();

                setTempElementSize(_this.getElementSize(_this.startX, event.clientX, elementSize, gridSize, minWidth));
            }, _this.onMouseUp = function (event) {
                var _this$props2 = _this.props,
                    setElementSize = _this$props2.setElementSize,
                    gridSize = _this$props2.gridSize,
                    element = _this$props2.element,
                    minWidth = _this$props2.minWidth;

                var elementSize = element.getIn(['content', 'width']);

                event.preventDefault();
                event.stopPropagation();

                document.removeEventListener('mousemove', _this.onMouseMove);
                document.removeEventListener('mouseup', _this.onMouseUp);

                setElementSize(_this.getElementSize(_this.startX, event.clientX, elementSize, gridSize, minWidth));
            }, _this.onMouseDown = function (event) {
                var setTempElementSize = _this.props.setTempElementSize;

                if (!setTempElementSize) return;

                event.preventDefault();
                event.stopPropagation();

                _this.startX = event.clientX;

                document.addEventListener('mousemove', _this.startDragging);
                document.addEventListener('mouseup', _this.cancelDragging);
            }, _this.onDoubleClick = function (event) {
                var _this$props3 = _this.props,
                    setElementSize = _this$props3.setElementSize,
                    gridSize = _this$props3.gridSize,
                    element = _this$props3.element,
                    defaultMaxWidth = _this$props3.defaultMaxWidth;


                if (!setElementSize) return;

                event.preventDefault();
                event.stopPropagation();

                var currentWidth = element.getIn(['content', 'width']);

                if (currentWidth > _elementConstants.ELEMENT_DEFAULT_WIDTH) return setElementSize(_elementConstants.ELEMENT_DEFAULT_WIDTH);

                return setElementSize((0, _lodash.max)([defaultMaxWidth / gridSize, _elementConstants.ELEMENT_DEFAULT_WIDTH]));
            }, _this.getElementSize = function (startX, currentX, elementSize, gridSize, minWidth) {
                var sizeChange = (currentX - startX) / gridSize;
                return (0, _calculateElementSize2.default)(elementSize, sizeChange, minWidth);
            }, _this.startDragging = function (event) {
                document.removeEventListener('mousemove', _this.startDragging);
                document.removeEventListener('mouseup', _this.cancelDragging);

                document.addEventListener('mousemove', _this.onMouseMove);
                document.addEventListener('mouseup', _this.onMouseUp);
            }, _this.cancelDragging = function (event) {
                document.removeEventListener('mousemove', _this.startDragging);
                document.removeEventListener('mouseup', _this.cancelDragging);
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(ElementResizeHandleMouse, [{
            key: 'render',
            value: function render() {
                return _react2.default.createElement(Component, _extends({}, this.props, { onMouseDown: this.onMouseDown, onDoubleClick: this.onDoubleClick }));
            }
        }]);

        return ElementResizeHandleMouse;
    }(_react2.default.Component);

    ElementResizeHandleMouse.propTypes = {
        children: _propTypes2.default.node,
        element: _propTypes2.default.object,
        gridSize: _propTypes2.default.number,
        inList: _propTypes2.default.string,
        showHandle: _propTypes2.default.bool,
        setElementSize: _propTypes2.default.func,
        setTempElementSize: _propTypes2.default.func,
        minWidth: _propTypes2.default.number,
        defaultMaxWidth: _propTypes2.default.number
    };

    return ElementResizeHandleMouse;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/resizing/elementResizeHandleMouseDecorator.js
// module id = 2007
// module chunks = 0